import { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Box, Typography, Button, Alert } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import AuthCard from '../components/AuthCard';
import { apiError } from '../i18n/errors';
import api from '../api/client';
import { colors } from '../colors';

export default function CheckEmail() {
  const location = useLocation();
  const email = location.state?.email || '';
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleResend = async () => {
    setLoading(true);
    setMessage('');
    try {
      await api.post('/auth/resend-verification/', { email });
      setMessage('✅ Email de vérification envoyé avec succès !');
    } catch (err) {
      setMessage(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard title="Vérifiez votre email">
      <Box sx={{ textAlign: 'center' }}>
        <EmailIcon sx={{ color: colors.primaryLight, fontSize: 64, mb: 2 }} />
        
        <Typography variant="h6" sx={{ color: colors.textPrimary, mb: 2, fontWeight: 600 }}>
          Consultez votre boîte mail
        </Typography>
        
        <Typography variant="body2" sx={{ color: colors.textSecondary, mb: 2 }}>
          Nous avons envoyé un email de confirmation à :
        </Typography>
        
        <Typography variant="body2" sx={{ color: colors.primaryLight, fontWeight: 600, mb: 3 }}>
          {email}
        </Typography>
        
        <Typography variant="body2" sx={{ color: colors.textSecondary, mb: 3 }}>
          Cliquez sur le lien dans l'email pour activer votre compte.
        </Typography>

        {message && (
          <Alert 
            severity={message.includes('succès') ? 'success' : 'error'} 
            sx={{ 
              mb: 3,
              bgcolor: message.includes('succès') ? 'rgba(34,197,94,0.15)' : 'rgba(239,68,68,0.15)',
              color: message.includes('succès') ? colors.success : colors.errorLight,
              border: `1px solid ${message.includes('succès') ? 'rgba(34,197,94,0.3)' : 'rgba(239,68,68,0.3)'}`,
            }}
          >
            {message}
          </Alert>
        )}

        <Button
          variant="outlined"
          fullWidth
          onClick={handleResend}
          disabled={loading}
          sx={{
            borderColor: 'rgba(129,140,248,0.3)',
            color: colors.primaryLight,
            mb: 2,
            '&:hover': {
              borderColor: colors.primaryLight,
              bgcolor: 'rgba(129,140,248,0.1)',
            },
          }}
        >
          {loading ? 'Envoi en cours...' : 'Renvoyer l\'email'}
        </Button>

        <Typography variant="caption" sx={{ color: colors.textSecondary, display: 'block', mb: 2 }}>
          Vous n'avez pas reçu l'email ? Vérifiez vos spams.
        </Typography>

        <Typography textAlign="center" variant="body2" sx={{ color: colors.textSecondary }}>
          <Link to="/" style={{ color: colors.textSecondary, textDecoration: 'none' }}>
            ← Retour à l'accueil
          </Link>
        </Typography>
      </Box>
    </AuthCard>
  );
}
